function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#MATIC_svg__clip0_1_76)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.717 9.17c-.551-.357-1.254-.357-1.884 0l-4.383 2.94-2.978 1.865-4.305 2.94c-.552.355-1.255.355-1.884 0L3.919 14.6c-.586-.386-.942-1.099-.942-1.866V8.281c0-.713.313-1.426.942-1.87l3.364-2.226c.551-.357 1.254-.357 1.884 0l3.363 2.314c.582.39.942 1.099.942 1.87v2.935l2.978-1.958V6.323a2.28 2.28 0 00-.942-1.87L9.24.27c-.546-.357-1.25-.357-1.879 0L.941 4.54C.314 4.897 0 5.611 0 6.323v8.364c0 .713.313 1.421.942 1.87l6.341 4.185c.551.357 1.254.357 1.884 0l4.305-2.847 2.978-1.957 4.31-2.852c.546-.357 1.25-.357 1.879 0l3.364 2.226c.585.391.941 1.104.941 1.87v4.454c0 .713-.312 1.425-.937 1.87l-3.29 2.226c-.551.352-1.254.352-1.884 0l-3.363-2.226c-.582-.39-.942-1.104-.942-1.87v-2.852l-2.978 1.958v2.94c0 .708.313 1.42.942 1.865l6.341 4.184c.552.357 1.255.357 1.884 0l6.341-4.184c.586-.39.942-1.099.942-1.87V15.22c0-.713-.313-1.421-.942-1.87l-6.341-4.18z",
  fill: "#8247E5"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "MATIC_svg__clip0_1_76"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h30v30H0z"
})));

function SvgMatic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "953f81071d63703727d653e3586c890f.svg";
export { SvgMatic as ReactComponent };